<template>
  <div class="register">
    {{error}}
    <loading :active.sync="isLoading" 
        :can-cancel="false"
        :color="color"
        :opacity="1"
        :is-full-page="fullPage"></loading>
    <div class="container center-content">
      <div class="row">
        <div class="col-sm dashboard-text-control" style="padding-bottom:30px">
          <h2>REGISTER</h2>
          <div class="alert alert-danger" v-if="checked" role="alert">Username or images not submit</div>
        </div>
        <div class="w-100"></div>
        <div class="col-sm">
          <div class="form-group">
            <label for="exampleInputEmail1">Username</label>
            <input
              v-model="username"
              type="email"
              class="form-control"
              aria-describedby="emailHelp"
              placeholder="Enter Your Username"
            />
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-sm" style="padding-top:25px">
          <vue-upload-multiple-image
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
            :data-images="images"
            :maxImage="5"
          ></vue-upload-multiple-image>
          <small>* Upload Your face 5 images</small>
        </div>
        <div class="w-100"></div>
        <div class="col-sm" style="padding-top:40px">
          <small style="text-color:red">{{aleart}}</small>
          <button
            type="button"
            @click="onClickRegister()"
            class="btn btn-outline-warning btn-lg btn-block round"
          >Register</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
const firebaseApp = require("../firebase.js");
const line = require("../line-config");

export default {
  data() {
    return {
      checked: false,
      username: "",
      images: [],
      aleart: "",
      color: '#d8737f',
      onCancel: true,
      displayName: null,
      isFinished: false,
      isLoading: false,
      fullPage: true,
      lineID: '',
      error: ''
    };
  },
  components: {
    VueUploadMultipleImage
  },
  mounted() {
    this.isLoading = true;
    const liff = this.$liff;
    liff
      .init({
        liffId: line.liffID
      })
      .then(() => {
        if(liff.isLoggedIn()) {
          this.isLoading = false;
          liff.getProfile().then(profile => {
            this.lineID = profile.userId

          })
        } else {
          this.isLoading = false;
          liff.login();
        }
      })
  },
  methods: {
    onClickRegister() {
      if (this.images.length != 5 && this.username == "") {
        this.checked = true;
      } if (this.images.length == 5 && this.username != ""){
        // eslint-disable-next-line no-unused-vars
        let postData = [];
        // eslint-disable-next-line no-redeclare
        for (var i =0; i < this.images.length; i++) {

          var str = this.images[i].path
          // eslint-disable-next-line no-unused-vars
          var res = str.replace(/^data:image\/[a-z]+;base64,/, "");
          postData.push(res)
        }

        this.isLoading = true;
        const body = {
          image: postData,
          name: this.username,
          lineID: this.lineID
        };

        // eslint-disable-next-line no-unused-vars
        axios.post("https://nuxline-ml27pmckyq-de.a.run.app/reverse", body).then(response => {
          
          firebaseApp.usersCollection.add({
            username: this.username,
            lineID:  this.lineID,

          }).then( () => {
              this.$router.back({ path: '/'});
          }).catch( () => {
            this.isLoading = false;
          })
        }).catch((e) => {
          this.error = e
           this.isLoading = false;
        });
      }
    },
    uploadImageSuccess(formData, index, fileList) {
      // let imageData = JSON.parse(JSON.stringify(fileList))
      this.images = JSON.parse(JSON.stringify(fileList));
      // console.log(this.images)

      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(index, done, fileList) {
      console.log("index", index, fileList);
      var r = confirm("remove image");
      if (r == true) {
        done();
      } else {
        done();
      }
    },
    editImage(formData, index, fileList) {
      console.log("edit data", formData, index, fileList);
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #475c7a;
  color: #ffffff;
  height: 100%;
  margin: 0;
}

.dashboard-text-control {
  padding-bottom: 20px;
}

h2 {
  text-shadow: 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
    0 5px 10px rgba(0, 0, 0, 0.25);
}

.center-content {
  padding-top: 20vh;
  @media (max-width: 767.98px) {
    padding-top: 5vh;
  }
}

.image-container {
  width: 100vw;
}

.dashboard-text-control {
  padding-bottom: 20px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width: 100vw;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

button:focus {
  outline: none;
}

*:focus {
  outline: none;
}
</style>